<div class="router-details-container" [formGroup]="form">
  <app-ice-input-field
    formControlName="imei"
    label="IMEI-nummeret til ruteren"
    ngDefaultControl
    ngxsFormPath="formState.mbbForm"
    placeholder="Scan eller skriv inn IMEI nummeret"
    textTestId="imei-input"
    [errorOnTouchedOnly]="!hasDuplicateImeiError"
    [errorText]="getImeiErrorText(imeiField?.errors)"
    [inputWidth]="'large'"
    [maxLength]="16"
    [minlength]="15"
    [showErrorOnLoad]="hasDuplicateImeiError"
  />

  <app-ice-input-field
    formControlName="icc"
    label="Registrer SIM-kort"
    ngDefaultControl
    ngxsFormPath="formState.mbbForm"
    placeholder="Scan eller skriv inn SIM-nummeret"
    textTestId="icc-input"
    [errorOnTouchedOnly]="true"
    [errorText]="getSimCardErrorTexts(iccField.errors, SimCardType.Mbb)"
    [inputWidth]="'large'"
    [maxlength]="20"
    [minlength]="19"
  />

  @if ((iccField.statusChanges | async) === FormStatus.PENDING || iccField.status === FormStatus.PENDING) {
    <app-spinner />
  }
</div>
